import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const FortuneWrap = styled.div`
  margin: 0 0 240px 0;
  display: block;
  ${customMedia.lessThan('tablet_cut_line')`
   margin: 0 0 155px 0;
   `}
`
const FortuneTab = styled.div`
  display: flex;
  border-bottom: 1px solid ${COLOR.blueGray2};
`

const FortuneTabItem = styled.p`
  font-family: NotoSansMedium, sans-serif;
  font-size: 16px;
  line-height: 23px;
  color: ${(props) => props.color};
  border-bottom: ${(props) => props.color === COLOR.black && '1px solid black'};
  margin: 0;
  padding: 8px 8px 9px 8px;
  cursor: pointer;
  ${customMedia.lessThan('tablet')`
    font-size: 14px;
    line-height:20px;
`}
`

const FortuneContents = styled.div<{ paddingBottom: string }>`
  display: block;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 3px 16px rgba(0, 0, 0, 0.08);
  margin-top: 32px;
  text-align: center;
  padding-bottom: ${(props) => props.paddingBottom};

  ${customMedia.lessThan('tablet')`
    margin-top: 13.5px;
  `}
  ${customMedia.lessThan('tablet_cut_line')`
    padding-bottom: unset;
    display: block;
    padding: 0 0 20px 0;

  `}
  > h3, h4 {
    margin: 0;
    display: block;
    font-family: NanumSquareNeoExtraBold, sans-serif;
    font-size: 20px;
    line-height: 22px;
  }

  > h3 {
    padding: 45px 0 30px 0;
    ${customMedia.lessThan('tablet_cut_line')`
     padding: 30px 0 35px 0;
  `}
  }

  > h4 {
    padding: 51px 0 30px 0;
  }
`

const FortuneSearchContsTop = styled.section`
  display: flex;
  width: 560px;
  margin: 0 auto;
  justify-content: space-between;
  ${customMedia.lessThan('tablet_cut_line')`
    max-width: 600px;
    margin: 0 16px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
  `}
`
const FortuneSearchContsBottom = styled.section`
  display: flex;
  width: 560px;
  margin: 36px auto 0 auto;
  justify-content: space-between;
  ${customMedia.lessThan('tablet_cut_line')`  
    display: flex;
    flex-wrap: wrap;
    max-width: 568px;
    width: 100%;
    margin: 23px 16px 0 16px;
    gap: 16px;
  `}
`
const FortuneSearchContsBox = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  display: block;

  > section {
    display: flex;
  }

  ${customMedia.lessThan('tablet_cut_line')`
    max-width: 568px;
 `}
`

const FortuneSearchSubTitle = styled.p`
  font-size: 16px;
  text-align: left;
  margin: 0;
  font-family: NotoSansMedium, sans-serif;
  line-height: 23px;
`

const FortuneSearchBoxInner = styled.div<{ active?: string }>`
  width: 100%;
  box-sizing: border-box;
  margin-top: 7px;
  border: 1px solid ${COLOR.blueGray2};
  border-radius: 8px;
  height: 40px;
  cursor: pointer;
  //max-width: 328px;

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    padding: 8px 0 8px 0;
  }

  .react-datepicker__navigation--next {
    margin-top: 8px;
  }

  .react-datepicker__header {
    background-color: #fff3f1;
    border-bottom: 1px solid #ced6e3;
  }

  .react-datepicker__input-container {
    width: 100%;
    > input {
      cursor: pointer;
      width: 100%;
      text-indent: 16px;
      font-size: 14px;
      line-height: 38px;
      font-family: NotoSansRegular, sans-serif;
      border-radius: 8px;
      border: none;
    }
  }

  .react-datepicker-popper {
    inset: unset !important;
    position: absolute !important;
    border: 1px solid red;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    z-index: 9996 !important;
  }

  .react-datepicker-ignore-onclickoutside {
    background: rgba(0, 0, 0, 0);
    pointer-events: none;
  }

  .react-datepicker__triangle {
    display: none;
  }

  > span {
    font-size: 14px;
    line-height: 40px;
    font-family: NotoSansRegular, sans-serif;
  }

  > img {
    display: inline-block;
    margin-left: 10px;
    width: 12px;
    height: 11px;
  }
`

const FortuneSearchCalModal = styled.div<{ active: string }>`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  height: ${(props) => (props.active === 'true' ? '1000vh' : 'auto')};
  width: ${(props) => (props.active === 'true' ? '100%' : 'auto')};
`

const FortuneResultWrap = styled.div`
  display: block;
  width: 560px;
  margin: 0 auto;
  ${customMedia.lessThan('tablet_cut_line')`
    max-width: 568px;
    width: 100%;
    margin: 0 auto;
`}
`

const FortuneResultImgSection = styled.div`
  display: flex;
  width: 560px;
  flex-wrap: wrap;
  justify-content: space-between;

  ${customMedia.lessThan('tablet')`
     &.horoscope{
        width: 324px;
        gap: 4px;
     }
     &.birth {
        width: 240px;
        gap: 12px;
     }
     margin: 0 auto;
     justify-content: center;
   `}
  > section {
    display: block;

    > p {
      font-family: NotoSansRegular, sans-serif;
      margin: 6px 0;
      font-size: 16px;
      line-height: 23px;
    }
  }
`
const FortuneResultDescSection = styled.div`
  > pre,
  > section {
    font-size: 16px;
    line-height: 23px;
    text-align: left;
    font-family: NotoSansRegular, sans-serif;
  }

  > pre {
    margin-top: 36px;
    white-space: normal;
    ${customMedia.lessThan('tablet')`
        margin-top: 24px;
        margin-bottom: 10px;
    `}
    ${customMedia.lessThan('tablet_cut_line')`
        margin: 24px auto 0 auto;
        max-width: 400px;
        padding: 0 16px;
        width: 100%;
        
    `}
  }

  > section {
    display: flex;
    ${customMedia.lessThan('tablet_cut_line')`
        margin: 5px auto;
        max-width: 400px;
        padding: 0 16px;
        width: 100%;
        
    `}
    > p {
      display: flex;
      font-weight: bold;
      margin: 0 5px 0 0;
    }

    > span {
      white-space: normal;
      display: flex;
    }
  }
`
const FortuneResultImg = styled.span<{ active: boolean; size: string }>`
  cursor: pointer;
  display: inline-block;
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  border-radius: 100px;
  background: ${(props) => (props.active ? COLOR.point3 : COLOR.point2)};

  .birth {
    margin: 15px;
    width: 72px;
    height: 72px;
    ${customMedia.lessThan('tablet')`
        width: 51px;
        height: 51px;
        margin: 10.5px;
    `}
  }

  .horoscope {
    width: 59px;
    height: 59px;
    margin: 11px;
    ${customMedia.lessThan('tablet')`
        width: 51px;
        height: 51px;
        margin: 10.5px;
    `}
  }
`

export {
  FortuneContents,
  FortuneResultDescSection,
  FortuneResultImg,
  FortuneResultImgSection,
  FortuneResultWrap,
  FortuneSearchBoxInner,
  FortuneSearchCalModal,
  FortuneSearchContsBottom,
  FortuneSearchContsBox,
  FortuneSearchContsTop,
  FortuneSearchSubTitle,
  FortuneTab,
  FortuneTabItem,
  FortuneWrap,
}
